module.exports = __webpack_public_path__ + "img/no-comment.250dfa75.png";